module.exports = __webpack_public_path__ + "static/media/downloads.d080f114.svg";